import { createFileRoute } from '@tanstack/react-router';
import { JourneysBroadcastsHandoff } from '@/pages/workspaces/broadcasts/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * `/journeys/broadcasts/welcome`, which Ember's route replaces with the list (`broadcasts.welcome`). Flag off the embedded app serves it; flag on it forwards to the migrated
 * list, which lands on the tab the reader was last on, query and hash carried. The resolver belongs
 * here: this URL keeps the `journeys` segment, so a `/workspaces/last` sentinel has to resolve
 * before the embedded app mounts on it.
 */
function JourneysBroadcastsWelcomeRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysBroadcastsHandoff tab={null} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/broadcasts/welcome')({
  component: JourneysBroadcastsWelcomeRoute,
});
